var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-upload",
      attrs: {
        id: "editGroup",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading == true,
                  expression: "(loading == true)"
                }
              ],
              staticClass: "loading-backdrop"
            },
            [_c("div", { staticClass: "loading" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.editGroup.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "center-modal ex-input-center" }, [
                  _c("div", { staticClass: "center-ttl text-center" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("group.edit.title")) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.alert_error
                    ? _c(
                        "div",
                        {
                          staticClass: "error-message",
                          attrs: { "data-vv-scope": "s0" }
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("i", { staticClass: "icon-warning mr-2" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "errror-txt" }, [
                              _c(
                                "p",
                                { staticClass: "fs-14 text-red font600" },
                                [_vm._v(_vm._s(_vm.$t("error.title")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "fs-14 text-red font600" },
                                [_vm._v(_vm._s(_vm.alert_error))]
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.editObj.ids.length > 1
                    ? _c("div", { attrs: { "data-vv-scope": "s1" } }, [
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("department.general.name")) +
                                " "
                            ),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("departmentId")
                              }
                            },
                            [
                              _c("select2", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "required",
                                    expression: "'required'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "departmentId",
                                attrs: {
                                  id: "departmentId",
                                  "data-vv-as": _vm.$t(
                                    "department.general.name"
                                  ),
                                  name: "departmentId",
                                  options: _vm.selectDepartmentId,
                                  settings: _vm.selectDepartmentIdSettings
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectDepartmentIdChangeEvent(
                                      $event
                                    )
                                  },
                                  select: function($event) {
                                    return _vm.selectDepartmentIdEvent($event)
                                  }
                                },
                                model: {
                                  value: _vm.group.departmentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.group, "departmentId", $$v)
                                  },
                                  expression: "group.departmentId"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("departmentId"),
                                      expression: "errors.has('departmentId')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.errors.first("departmentId"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.editObj.ids.length == 1
                    ? _c("div", { attrs: { "data-vv-scope": "s2" } }, [
                        _vm.group.type == _vm.groupType.branch.id
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.group.type == _vm.groupType.branch.id,
                                    expression:
                                      "group.type == groupType.branch.id"
                                  }
                                ],
                                attrs: { "data-vv-scope": "t1" }
                              },
                              [
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("company.general.full_name")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "companyName"
                                        )
                                      }
                                    },
                                    [
                                      _c("select2", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required",
                                            expression: "'required'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "companyName",
                                        attrs: {
                                          id: "companyName",
                                          name: "companyName",
                                          "data-vv-as": _vm.$t(
                                            "company.general.full_name"
                                          ),
                                          options: _vm.selectCompanyId,
                                          settings: _vm.selectCompanyIdSettings
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectCompanyChangeEvent(
                                              $event
                                            )
                                          },
                                          select: function($event) {
                                            return _vm.selectCompanyEvent(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.group.companyId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.group,
                                              "companyId",
                                              $$v
                                            )
                                          },
                                          expression: "group.companyId"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "companyName"
                                              ),
                                              expression:
                                                "errors.has('companyName')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("companyName")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("branch.general.code")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "branchCode"
                                        )
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.group.branchCode,
                                            expression: "group.branchCode"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required|numeric|digits:4",
                                            expression:
                                              "'required|numeric|digits:4'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "branchCode",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "off",
                                          name: "branchCode",
                                          placeholder: _vm.$t(
                                            "place_holder.branch_code"
                                          ),
                                          "data-vv-as": _vm.$t(
                                            "branch.general.code"
                                          )
                                        },
                                        domProps: {
                                          value: _vm.group.branchCode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.group,
                                              "branchCode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "branchCode"
                                              ),
                                              expression:
                                                "errors.has('branchCode')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("branchCode")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("branch.general.full_name")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "branchName"
                                        )
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.group.branchName,
                                            expression: "group.branchName"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required|min:1|max:255",
                                            expression:
                                              "'required|min:1|max:255'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "branchName",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "off",
                                          name: "branchName",
                                          placeholder: _vm.$t(
                                            "place_holder.branch_full_name"
                                          ),
                                          "data-vv-as": _vm.$t(
                                            "branch.general.full_name"
                                          )
                                        },
                                        domProps: {
                                          value: _vm.group.branchName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.group,
                                              "branchName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "branchName"
                                              ),
                                              expression:
                                                "errors.has('branchName')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("branchName")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.boxFoldersLoading
                                  ? _c(
                                      "div",
                                      { staticClass: "box-folder-block" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "box-folder-title" },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "group.edit.box_folder.folder_id"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.boxFolderRows.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "box-folder-table-wrap"
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table box-folder-table"
                                                  },
                                                  [
                                                    _vm._m(0),
                                                    _vm._v(" "),
                                                    _c("thead", [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "box-folder-year"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "general.fiscal_year"
                                                                    )
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.boxFolderTypes,
                                                            function(type) {
                                                              return _c(
                                                                "th",
                                                                {
                                                                  key: type.id
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        type.name
                                                                      ) +
                                                                      "\n                                                    "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.boxFolderRows,
                                                        function(row) {
                                                          return _c(
                                                            "tr",
                                                            {
                                                              key:
                                                                row.fiscal_year
                                                            },
                                                            [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "box-folder-year"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        row.fiscal_year
                                                                      ) +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "general.fiscal_year"
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.boxFolderTypes,
                                                                function(type) {
                                                                  return _c(
                                                                    "td",
                                                                    {
                                                                      key:
                                                                        type.id,
                                                                      staticClass:
                                                                        "box-folder-id"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            row
                                                                              .folders[
                                                                              type
                                                                                .id
                                                                            ] ||
                                                                              ""
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "box-folder-empty"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "group.edit.box_folder.no_data"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.group.type == _vm.groupType.department.id
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.group.type ==
                                      _vm.groupType.department.id,
                                    expression:
                                      "group.type == groupType.department.id"
                                  }
                                ],
                                attrs: { "data-vv-scope": "t2" }
                              },
                              [
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("branch.general.name")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "branchId"
                                        )
                                      }
                                    },
                                    [
                                      _c("select2", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required",
                                            expression: "'required'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "branchId2",
                                        attrs: {
                                          id: "branchId2",
                                          "data-vv-as": _vm.$t(
                                            "branch.general.name"
                                          ),
                                          name: "branchId",
                                          options: _vm.selectBranchId,
                                          settings: _vm.selectBranchIdSettings
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectBranchIdChangeEvent(
                                              $event
                                            )
                                          },
                                          select: function($event) {
                                            return _vm.selectBranchIdEvent(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.group.branchId,
                                          callback: function($$v) {
                                            _vm.$set(_vm.group, "branchId", $$v)
                                          },
                                          expression: "group.branchId"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has("branchId"),
                                              expression:
                                                "errors.has('branchId')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.errors.first("branchId"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("department.general.code")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "departmentCode"
                                        )
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.group.departmentCode,
                                            expression: "group.departmentCode"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required|numeric|digits:2",
                                            expression:
                                              "'required|numeric|digits:2'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "departmentCode",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "off",
                                          name: "departmentCode",
                                          placeholder: _vm.$t(
                                            "place_holder.department_code"
                                          ),
                                          "data-vv-as": _vm.$t(
                                            "department.general.code"
                                          )
                                        },
                                        domProps: {
                                          value: _vm.group.departmentCode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.group,
                                              "departmentCode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "departmentCode"
                                              ),
                                              expression:
                                                "errors.has('departmentCode')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("departmentCode")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "department.general.full_name"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "departmentName"
                                        )
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.group.departmentName,
                                            expression: "group.departmentName"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required|min:1|max:255",
                                            expression:
                                              "'required|min:1|max:255'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "departmentName",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "off",
                                          name: "departmentName",
                                          placeholder: _vm.$t(
                                            "place_holder.department_full_name"
                                          ),
                                          "data-vv-as": _vm.$t(
                                            "department.general.full_name"
                                          )
                                        },
                                        domProps: {
                                          value: _vm.group.departmentName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.group,
                                              "departmentName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "departmentName"
                                              ),
                                              expression:
                                                "errors.has('departmentName')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("departmentName")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.group.type == _vm.groupType.group.id
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.group.type == _vm.groupType.group.id,
                                    expression:
                                      "group.type == groupType.group.id"
                                  }
                                ],
                                attrs: { "data-vv-scope": "t3" }
                              },
                              [
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("department.general.name")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "departmentId"
                                        )
                                      }
                                    },
                                    [
                                      _c("select2", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required",
                                            expression: "'required'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "branchId1",
                                        attrs: {
                                          id: "branchId1",
                                          "data-vv-as": _vm.$t(
                                            "department.general.name"
                                          ),
                                          name: "departmentId",
                                          options: _vm.selectDepartmentId,
                                          settings:
                                            _vm.selectDepartmentIdSettings
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.selectDepartmentIdChangeEvent(
                                              $event
                                            )
                                          },
                                          select: function($event) {
                                            return _vm.selectDepartmentIdEvent(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.group.departmentId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.group,
                                              "departmentId",
                                              $$v
                                            )
                                          },
                                          expression: "group.departmentId"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "departmentId"
                                              ),
                                              expression:
                                                "errors.has('departmentId')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("departmentId")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.$t("group.general.code")) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "groupCode"
                                        )
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.group.groupCode,
                                            expression: "group.groupCode"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required|numeric|digits:3",
                                            expression:
                                              "'required|numeric|digits:3'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "groupCode",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "off",
                                          name: "groupCode",
                                          placeholder: _vm.$t(
                                            "place_holder.group_code"
                                          ),
                                          "data-vv-as": _vm.$t(
                                            "group.general.code"
                                          )
                                        },
                                        domProps: {
                                          value: _vm.group.groupCode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.group,
                                              "groupCode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "groupCode"
                                              ),
                                              expression:
                                                "errors.has('groupCode')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("groupCode")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-input" }, [
                                  _c(
                                    "label",
                                    { staticClass: "form-input-lb" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t("group.general.full_name")
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v("*")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-input-cnt",
                                      class: {
                                        "ex-has-error": _vm.errors.has(
                                          "groupName"
                                        )
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.group.groupName,
                                            expression: "group.groupName"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.disable",
                                            value: "required|min:1|max:255",
                                            expression:
                                              "'required|min:1|max:255'",
                                            modifiers: { disable: true }
                                          }
                                        ],
                                        key: "groupName",
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          autocomplete: "off",
                                          name: "groupName",
                                          placeholder: _vm.$t(
                                            "place_holder.group_full_name"
                                          ),
                                          "data-vv-as": _vm.$t(
                                            "group.general.full_name"
                                          )
                                        },
                                        domProps: {
                                          value: _vm.group.groupName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.group,
                                              "groupName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "groupName"
                                              ),
                                              expression:
                                                "errors.has('groupName')"
                                            }
                                          ],
                                          staticClass: "error-text"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first("groupName")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.editObj.ids.length >= 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center mt-4 pt-4",
                          attrs: { "data-vv-scope": "s3" }
                        },
                        [
                          _c("div", { staticClass: "pr-2 w-165" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-pink-53 w-100",
                                attrs: {
                                  type: "submit",
                                  disabled: _vm.submitted
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("button.ok")) +
                                    "\n                                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pl-2 w-165" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-gray-53 w-100",
                                attrs: {
                                  "data-dismiss": "modal",
                                  type: "button",
                                  disabled: _vm.submitted
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("button.cancel")) +
                                    "\n                                "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.editObj.ids.length < 1
                    ? _c("div", { attrs: { "data-vv-scope": "s4" } }, [
                        _c("div", {}, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("group.general.no_select")) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center mt-4 pt-4"
                          },
                          [
                            _c("div", { staticClass: "pl-2 w-165" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-pink-53 w-100",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    type: "button"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("button.ok")) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticClass: "box-folder-year-col" }),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48def874", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48def874","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/admin/GroupManagement/Edit.vue
// module id = null
// module chunks = 